export const maquetaTpl = {
  modalDatos: {
    regTitle: `Registrierungsdaten`,
    paymentMethod: `Zahlungsart`,
    paymentDate: `Zahlungsdatum`,
    guestCount: `Anzahl der Gäste`,
    unspecified: `Nicht angegeben`,
    pay: {
      DESTI: `Zahlung vor Ort`,
      EFECT: `Bar`,
      MOVIL: `Mobile Zahlung`,
      OTRO: `Andere Zahlungsarten`,
      PLATF: `Zahlungsplattform`,
      TARJT: `Kreditkarte`,
      TRANS: `Banküberweisung`,
      TREG: `Geschenkkarte`,
    },
  },
  whatsapp: {
    title: `Exklusiver WhatsApp-Business-Zugang`,
    body: `Für die Nutzung der WhatsApp-Business-Funktion ist ein aktives persönliches WhatsApp-Business-Abo erforderlich. Diese Option gibt Ihnen zusätzliche Werkzeuge und erweiterte Funktionen, um Ihr Geschäft voranzubringen.`,
  },
  nav: {
    welcome: `Willkommen`,
    manager: `Manager`,
    logout: `Abmelden`,
    logoutError: `Beim Abmelden ist leider ein Fehler aufgetreten`,
  },
  subnav: {
    home: `Start`,
    clients: `Kunden`,
    prices: `Preise`,
    payments: `Zahlungen`,
    userManagement: `Benutzerverwaltung`,
  },
};
